import { useState } from 'react';
import { ExportFormat, TimeRange } from '../custom-components/IngestionExportModal';
import { ingestionsApi } from '../services/ingestions.service';
import General from '../utils/GeneralUtils';

interface UseIngestionExportReturn {
  exportIngestions: (siteId: string, teamId: string, format: ExportFormat, timeRange: TimeRange, stateFilter?: string | null) => Promise<void>;
  isExporting: boolean;
  exportResponse: any;
  exportError: string | null;
}

export const useIngestionExport = (): UseIngestionExportReturn => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportResponse, setExportResponse] = useState<any>(null);
  const [exportError, setExportError] = useState<string | null>(null);
  
  const exportIngestions = async (siteId: string, teamId: string, format: ExportFormat, timeRange: TimeRange, stateFilter?: string | null) => {
    try {
      setIsExporting(true);
      setExportError(null);
      
      // Calculate date range based on selection
      const now = new Date();
      let startDate: Date;
      
      switch (timeRange) {
        case '1_MONTH':
          startDate = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
          break;
        case '3_MONTHS':
          startDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
          break;
        case '6_MONTHS':
          startDate = new Date(now.getFullYear(), now.getMonth() - 6, now.getDate());
          break;
        default:
          startDate = new Date(now.getFullYear(), now.getMonth() - 3, now.getDate());
      }
      
      // Build the query for ingestions
      const query: any[] = [
        {
          field: 'siteId',
          operator: 'equals',
          value: siteId
        },
        {
          field: 'ingestedAt',
          operator: 'between',
          value: [startDate.toISOString(), now.toISOString()]
        }
      ];

      // Add state filter if provided
      if (stateFilter) {
        query.push({
          field: 'geo.subdivisions.isoCode',
          operator: 'equals',
          value: stateFilter
        });
      }
      
      // Call the export API
      const response = await ingestionsApi.exportIngestions({
        target: format,
        query: query,
        siteId: siteId,
        teamId: teamId!
      });
      
      if (response.data) {
        setExportResponse(response.data);
        console.log('Ingestion export started successfully:', response.data);
      }
    } catch (error) {
      General.logAndToastError('Failed to start ingestion export', error);
    } finally {
      setIsExporting(false);
    }
  };
  
  return {
    exportIngestions,
    isExporting,
    exportResponse,
    exportError
  };
};